import React from 'react'

const CarouselSlider = ({ children, superElmIdx }) => {
  return (
    <div
      className="thumb-container"
      id={`scrollRow-${parseInt(superElmIdx) + 1}`}
    >
      <div className="thumb-slider">{children}</div>
    </div>
  )
}

export default CarouselSlider
